import React from 'react';

function Close() {
    return (
        <g>
            <path d="M0.6,23.4c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1L12,12.7l10.6,10.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1
                c0.2-0.2,0.2-0.5,0-0.7L12.7,12L23.4,1.4c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L12,11.3L1.4,0.6c-0.2-0.2-0.5-0.2-0.7,0
                s-0.2,0.5,0,0.7L11.3,12L0.6,22.6C0.5,22.8,0.5,23.2,0.6,23.4z"
            />
        </g>
    );
}

export default Close;
